import { withMarginTw } from "../styles/withMargin";
import { classNames } from "../utils/cn";

type AlertType = "success" | "error" | "warning" | "info";
interface Props {
  type: AlertType;
  text: string;
  margin?: string;
}

const borderColor: Record<AlertType, string> = {
  success: "border-green-400",
  error: "border-red-400",
  warning: "border-orange-400",
  info: "border-blue-200",
};

const bgColor: Record<AlertType, string> = {
  success: "bg-green-400/20",
  error: "bg-red-400/20",
  warning: "bg-orange-400/20",
  info: "bg-blue-50",
};

const textColor: Record<AlertType, string> = {
  success: "text-green-700",
  error: "text-red-700",
  warning: "text-orange-700",
  info: "text-blue-600",
};

export function Alert(props: Props) {
  const m = withMarginTw({ margin: props.margin });
  return (
    <div
      className={classNames(
        "border border-solid rounded-md p-2",
        m,
        borderColor[props.type],
        bgColor[props.type],
      )}
    >
      <p
        className={classNames(
          textColor[props.type],
          "m-0 text-sm font-semibold",
        )}
      >
        {props.text}
      </p>
    </div>
  );
}
